import React from 'react'

import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './radix-dlt.css'

const RadixDLT = (props) => {
  return (
    <div className="radix-dlt-container10">
      <Helmet>
        <title>Radix Design Concepts | Vlad Butucariu</title>
        <meta
          name="description"
          content="Selected web, product communication, and visual design concepts created by Vlad Butucariu for the Radix ecosystem."
        />
        <meta
          property="og:title"
          content="Radix Design Concepts | Vlad Butucariu"
        />
        <meta
          property="og:description"
          content="Explorations in making complex distributed-ledger technology clearer and more tangible."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-default.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/radix-dlt" />
        <meta
          property="og:url"
          content="https://vladbutucariu.com/radix-dlt"
        />
      </Helmet>
      <div className="radix-dlt-thq-wrapper-elm">
        <TopMenu text3="Capabilities"></TopMenu>
        <div className="radix-dlt-thq-top-section-elm">
          <div className="radix-dlt-thq-video-div-elm">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="radix-dlt-video"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="radix-dlt-thq-video-mobile-elm"
            ></video>
          </div>
          <div className="radix-dlt-thq-section-elm1">
            <div className="radix-dlt-thq-color-wrapper-elm1 project-page-shell">
              <div className="radix-dlt-container11 project-page-intro">
                <div className="radix-dlt-container12">
                  <img
                    alt="image"
                    src="/Images/tickerpurple.200.svg"
                    className="radix-dlt-image10"
                  />
                  <div className="radix-dlt-container13">
                    <h1 className="radix-dlt-text10 header-project">
                      RADIX DLT
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </h1>
                    <div className="radix-dlt-container14">
                      <span className="radix-dlt-text11">
                        generative vector art
                      </span>
                      <span className="radix-dlt-text12">on ledger</span>
                    </div>
                  </div>
                  <h2 className="radix-dlt-text13">
                    <span>
                      Over several years in the Radix ecosystem, my work spanned
                      design solutions for product communication, webpages,
                      marketing materials, and applications. Some were produced
                      and others remained explorations; this page collects a
                      representative selection.
                    </span>
                    <br></br>
                  </h2>
                </div>
                <div className="radix-dlt-container15">
                  <img
                    alt="image"
                    src="/Projects/radix%20dlt-1400w.png"
                    className="radix-dlt-image11"
                  />
                  <div className="radix-dlt-container16">
                    <div className="radix-dlt-container17">
                      <label className="radix-dlt-text16 tag-label-big">
                        ui/ux
                      </label>
                      <label className="radix-dlt-text17 tag-label-big">
                        branding
                      </label>
                    </div>
                    <div className="radix-dlt-thq-out-link-elm">
                      <a
                        href="https://radixdlt.com"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="radix-dlt-link"
                      >
                        https://radixdlt.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="radix-dlt-thq-section-elm2">
          <div className="radix-dlt-thq-label-elm">
            <span className="radix-dlt-text20">Loopers</span>
            <span className="radix-dlt-text21">
              animation, nft, collection, art
            </span>
          </div>
          <div className="radix-dlt-container21">
            <div className="radix-dlt-thq-item-elm10">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="radix-dlt-image12"
              />
            </div>
            <div className="radix-dlt-thq-item-elm11">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="radix-dlt-image13"
              />
            </div>
            <div className="radix-dlt-thq-item-elm12">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="radix-dlt-image14"
              />
            </div>
            <div className="radix-dlt-thq-item-elm13">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="radix-dlt-image15"
              />
            </div>
            <div className="radix-dlt-thq-item-elm14">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="radix-dlt-image16"
              />
            </div>
            <div className="radix-dlt-thq-item-elm15">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="radix-dlt-image17"
              />
            </div>
            <div className="radix-dlt-thq-item-elm16">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="radix-dlt-image18"
              />
            </div>
            <div className="radix-dlt-thq-item-elm17">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="radix-dlt-image19"
              />
            </div>
            <div className="radix-dlt-thq-item-elm18">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="radix-dlt-image20"
              />
            </div>
            <div className="radix-dlt-thq-item-elm19">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="radix-dlt-image21"
              />
            </div>
            <div className="radix-dlt-thq-item-elm20">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="radix-dlt-image22"
              />
            </div>
            <div className="radix-dlt-thq-item-elm21">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="radix-dlt-image23"
              />
            </div>
            <div className="radix-dlt-thq-item-elm22">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="radix-dlt-image24"
              />
            </div>
            <div className="radix-dlt-thq-item-elm23">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="radix-dlt-image25"
              />
            </div>
            <div className="radix-dlt-thq-item-elm24">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="radix-dlt-image26"
              />
            </div>
            <div className="radix-dlt-thq-item-elm25">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="radix-dlt-image27"
              />
            </div>
            <div className="radix-dlt-thq-item-elm26">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="radix-dlt-image28"
              />
            </div>
            <div className="radix-dlt-thq-item-elm27">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="radix-dlt-image29"
              />
            </div>
          </div>
        </div>
        <div className="radix-dlt-thq-section-elm3">
          <div className="radix-dlt-thq-color-wrapper-elm2">
            <div className="radix-dlt-container22">
              <div className="radix-dlt-thq-pic-elm1">
                <div className="radix-dlt-thq-description-elm1">
                  <p className="radix-dlt-text22">
                    <span>
                      This update proposal was made for the Homepage of Radix
                      DLT. The relatively subtle changes had the role of
                      enhancing the communication for new visitors and
                      reflecting better the Title in the header with a dynamic
                      3D illustration.
                    </span>
                    <br></br>
                    <br></br>
                    <span>
                      On the background can be observed a dynamic composition in
                      which abstract &quot;Assets&quot; are being composed to
                      form the Universal Stack. On top of that subtle changes
                      were made also to various elements for a slick look.
                    </span>
                  </p>
                </div>
                <img
                  alt="image"
                  src="/Projects/radix%20homepage%20redo.png"
                  className="radix-dlt-image30"
                />
                <div className="radix-dlt-thq-description-elm2">
                  <p className="radix-dlt-text27">
                    Current homepage based on which the proposal was made -
                    below.
                  </p>
                </div>
                <img
                  alt="image"
                  src="/Projects/current%20radix%20homepage.png"
                  className="radix-dlt-image31"
                />
              </div>
              <div className="radix-dlt-thq-pic-elm2">
                <div className="radix-dlt-thq-description-elm3">
                  <p className="radix-dlt-text28">
                    <span className="radix-dlt-text29">
                      The following landing page was as well shaped starting
                      from a template by the official Radix DLT design team. The
                      project wanted to build a separate page for the Radix
                      Labs, a research branch under the stewardship of the Radix
                      Foundation.
                    </span>
                    <br></br>
                    <br></br>
                    <span>
                      The community was asked to contribute ideas for both the
                      design and message. Having been involved with the project
                      since 2017, I developed several suggestions:
                    </span>
                    <br></br>
                    <br></br>
                    <span>
                      1. Using the Hyperscale term vehiculating in the
                      community, as the title in the header to emphasize the
                      unlimited scalability of this unique layer 1 DLT. 
                    </span>
                    <br></br>
                    <span>
                      2. To make the concept of unlimited scalability tangible
                      and visible for new users an interactive counter was
                      introduced, where visitors can add nodes and therefore can
                      see how the TPS (transactions per second) are added
                      infinitely. 
                    </span>
                    <br></br>
                    <span>
                      3. A side by side comparison table with competing projects
                      where is visible not just the TPS but also the Swaps,
                      which is an even more challenging thing to achieve for a
                      scalable DLT, but where Radix excells.
                    </span>
                    <br></br>
                    <span>
                      4. A detailed roadmap where all the iterations of the
                      project are being seen and with each of them the
                      improvements in architecture and TPS.
                    </span>
                    <br></br>
                  </p>
                </div>
                <img
                  alt="image"
                  src="/Projects/radix%20labs%20landing%20page%20-%20%20proposal.png"
                  className="radix-dlt-image32"
                />
              </div>
            </div>
          </div>
        </div>
        <Footer rootClassName="footerroot-class-name5"></Footer>
      </div>
    </div>
  )
}

export default RadixDLT
